module.exports = __webpack_public_path__ + "img/thumbnail_Raccoon_f_albino.4df285cd.png";